import { useEffect, useState } from 'react';

const useResponsiveFontSize = (baseFontSize = 16) => {
  const [fontSize, setFontSize] = useState(baseFontSize);
  const [scrollbarWidth, setScrollbarWidth] = useState(0);

  // 计算滚动条宽度
  useEffect(() => {
    const calculateScrollbarWidth = () => {
      const outer = document.createElement('div');
      outer.style.visibility = 'hidden';
      outer.style.overflow = 'scroll';
      outer.style.width = '100px';
      outer.style.height = '100px';
      document.body.appendChild(outer);
      
      const inner = document.createElement('div');
      inner.style.width = '100%';
      inner.style.height = '200px'; // 确保有滚动
      outer.appendChild(inner);
      
      const width = outer.offsetWidth - inner.offsetWidth;
      document.body.removeChild(outer);
      
      const scrollbarWidth = width > 0 ? Math.floor(width + 1) : 0;
      setScrollbarWidth(scrollbarWidth);
      window.__SCROLLBAR_WIDTH = scrollbarWidth;
    };
    
    calculateScrollbarWidth();
  }, []);

  // 精确计算字体大小
const calculateFontSize = () => {
  const { innerWidth, innerHeight } = window;
  let fontSize = baseFontSize;

  if (innerHeight >= innerWidth) {
    const designWidth = 750;
    const designHeight = 1334;
    const screenRatio = innerWidth / innerHeight;
    const designRatio = designWidth / designHeight;

    fontSize *= screenRatio > designRatio
      ? innerHeight / designHeight
      : innerWidth / designWidth;
  } else {
    fontSize *= innerWidth / 1920;
  }

  return fontSize;
};

  // 应用字体大小
  useEffect(() => {
    let resizeTimer;
    const html = document.documentElement;
    
    const handleResize = (initial = false) => {
      const newFontSize = calculateFontSize();
      
      // 应用字体大小
      if (initial) {
        // 首次加载，插入 style 标签
        const styleElem = document.createElement('style');
        styleElem.id = 'responsive-font-size';
        styleElem.innerText = `html { font-size: ${newFontSize}px !important; }`;
        document.head.appendChild(styleElem);
      } else {
        // 后续调整
        html.style.fontSize = `${newFontSize}px`;
      }
      
      // 修正字体大小（如果浏览器有最小字体限制）
      const computedFontSize = parseFloat(
        window.getComputedStyle(html).fontSize
      );
      
      if (computedFontSize !== newFontSize && computedFontSize > 0) {
        const correctedFontSize = (newFontSize * newFontSize) / computedFontSize;
        html.style.fontSize = `${correctedFontSize}px`;
        setFontSize(correctedFontSize);
        window.__ROOT_FONT_SIZE = correctedFontSize;
      } else {
        setFontSize(newFontSize);
        window.__ROOT_FONT_SIZE = newFontSize;
      }
      
      // HarmonyOS 特殊处理
      if (window.navigator.userAgent.includes('HarmonyOS')) {
        const viewportMeta = document.querySelector('meta[name=viewport]');
        const radio = window.devicePixelRatio || 1;
        if (viewportMeta) {
          viewportMeta.setAttribute(
            'content',
            `width=${window.outerWidth * radio}px, initial-scale=${(1 / radio).toFixed(3)}, maximum-scale=${(1 / radio).toFixed(3)}, user-scalable=0`
          );
        }
      }
    };
    
    // 初始化
    handleResize(true);
    
    // 监听窗口变化
    const handleWindowResize = () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        handleResize(false);
      }, 100);
    };
    
    window.addEventListener('resize', handleWindowResize);
    
    return () => {
      window.removeEventListener('resize', handleWindowResize);
      clearTimeout(resizeTimer);
    };
  }, [baseFontSize]);

  return { fontSize, scrollbarWidth };
};

export default useResponsiveFontSize;